export enum ETimePeriod {
  AM = 'AM',
  PM = 'PM',
}

export const NUMBERS_BEFORE_COLON_LENGTH = 2;

export const TIME_FORMAT_12H = 'hh:mm a';
